<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-6 text-sm-right">
            <button *hasPermission="{app: constant.PERMISOS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect"
              (click)="openModal()"><i
                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
          </div>
        </div>
      </div>
      <div class="container card-body table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
          class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of dataPermiso ;let indice=index">
              <td>{{indice+1}}</td>
              <td>{{ row.nombre}}</td>
              <td>{{ row.descripcion }}</td>
              <td>{{ row.estado == "1" ? "Activo" : "Inactivo" }}</td>
              <td class="text-center" style="width:50px">
                <div class="row">
                  <button  *hasPermission="{app: constant.PERMISOS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar"
                    class="btn btn-sm btn-link waves-effect  col px-1"
                    title="Editar este registro"
                    (click)="edit(row)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </button>
                  <button *hasPermission="{app: constant.PERMISOS, permission: [constant.BORRAR]}" type="button"
                    class="btn btn-sm btn-link waves-effect col px-1"
                    title="Eliminar este registro"
                    (click)="delete(row.idSprPermiso)">
                    <i class="fas fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-permisos" [isDelete]="true"
  (confirmation)="confirmDelete()"></jw-modal>

<jw-modal id="{{nameModal}}">
  <!-- MODAL PARA CREAR Y EDITAR -->
  <div class="modal-dialog" style="padding-top:6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{nameApp}}</h3>
        <button type="button" class="btn-close" (click)="modal.close();"
          aria-label="Close"></button>
      </div>

      <div class="modal-body pT-4">

        <form class="needs-validation" novalidate id="formPermiso"
          [formGroup]="formPermiso">

          <div class="row">
            <input type="hidden" id="idSprPermiso"
              formControlName="idSprPermiso">

            <div class="form-floating mb-3">
              <input id="idSprPermiso" type="text" maxlength="50"
                class="form-control upperCase" required="true"
                formControlName="nombre"
               [ngClass]="{
                          'is-invalid': this.formPermiso.get('nombre')?.errors && this.formSubmitted,
                          'is-valid': !this.formPermiso.get('nombre')?.errors,
                        }" />
              <small class="invalid-feedback"
                *ngIf="this.formPermiso.get('nombre')?.errors?.['required'] && this.formSubmitted">
                Campo requerido</small>
              <label for="idSprPermiso" class="col-form-label text-md-right"><b>Nombre</b>
              </label>
            </div>

            <div class="form-floating mb-3">
              <textarea type="text" class="form-control" required="true"
                formControlName="descripcion"
                maxlength="250" [ngClass]="{
                          'is-invalid': this.formPermiso.get('descripcion')?.errors && this.formSubmitted,
                          'is-valid': !this.formPermiso.get('descripcion')?.errors,
                        }"></textarea>
              <small class="invalid-feedback"
                *ngIf="this.formPermiso.get('descripcion')?.errors?.['required'] && this.formSubmitted">
                Campo requerido</small>

              <label for="descripcion">Descripción</label>
            </div>
            <div class="form-floating mb-3">
              <select id="estado" class="form-select" formControlName="estado"
                required="true" [ngClass]="{
                            'is-invalid': this.formPermiso.get('estado')?.errors && this.formSubmitted,
                            'is-valid': !this.formPermiso.get('estado')?.errors,
                          }">
                <option value="1" selected>Activo</option>
                <option value="2">Inactivo</option>
              </select>
              <label for="estado">Estado</label>
              <small class="invalid-feedback"
                *ngIf="this.formPermiso.get('estado')?.errors?.['required'] && this.formSubmitted">
                Campo
                requerido</small>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect"
          (click)="modal.close();">Cerrar</button>
        <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
      </div>
    </div>
  </div>
</jw-modal>
